import { useEffect, useState } from "react";
import postHogFeatureFlagKeys from "@ch/helpers/utils/postHogAnalytics/postHogFeatureFlagKeys.ts";
import usePostHogFeatureFlag from "@ch/helpers/utils/postHogAnalytics/usePostHogFeatureFlag.ts";
import CloseIcon from "@ch/assets/icons/pack/CloseIcon.tsx";

interface WarningPayload {
  message: string;
}

function BannerChatsDisabledWarning() {
  const { isFeatureFlagEnabled, payload } =
    usePostHogFeatureFlag<WarningPayload>({
      featureFlagName: postHogFeatureFlagKeys.DISABLE_CHATS_AND_FORUMS,
    });
  const [isBannerEnabled, setIsBannerEnabled] = useState<boolean | undefined>(
    isFeatureFlagEnabled,
  );

  useEffect(() => {
    setIsBannerEnabled(isFeatureFlagEnabled);
  }, [isFeatureFlagEnabled]);

  if (!isBannerEnabled) return null;

  return (
    <div className="relative bg-[#f89406] px-6 py-4 text-center font-bold text-white">
      <p className="m-auto max-w-[800px]">{payload?.message}</p>
      <button
        className="absolute right-2 top-2 cursor-pointer"
        onClick={() => setIsBannerEnabled(false)}
        type="button"
      >
        <CloseIcon />
      </button>
    </div>
  );
}

export default BannerChatsDisabledWarning;
